import type { CookieCircuitBreakerConfig } from '@jira/platform__routing-route-types/src/JiraSpaRoute.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import killswitch from '@jira/platform__utils-feature-gates-killswitch';

export function getSsrCircuitBreaker(): CookieCircuitBreakerConfig {
	return {
		isSetCookieEnabled: true,
		isMonitoringEnabled: true,
		isCircuitBreakerEnabled: !killswitch('issue-navigator-cookie-cb'),
		cookieKey: 'nin',
		windowSize: 10,
		halfOpenForCount: 5,
		threshold: 0.7,
		keepOpenCount: 20,
	};
}
